import { Component ,OnInit} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms'
import { FileService } from '../../shared/_services/file.service';



@Component({
  selector: 'app-counter-component',
  templateUrl: './counter.component.html'
})
export class CounterComponent{
  public progress: number;
  public message: string;
  error: string;

  constructor(private fb: FormBuilder, private fileUploadService: FileService) { }
   
  upload(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();

    for (let file of files)
      formData.append(file.name, file);


    //this.fileUploadService.uploadFile(formData).subscribe((res: any) => {
    //  if (res.ininforFaltante) {
    //    //Proceso para continuar Cargando informacion
    //  } else {
    //    //proceso finalizar cargue
    //    this.message = res.message;
    //  }
    //  console.log(res)
    //},
    //  err => this.error = err
    //);;
  }
  
}
